import { Controller } from "@hotwired/stimulus";
import { AdjustHeight } from "../shared/adjust_height";

// Connects to data-controller="resumin--self-promotion-example-copy"
export default class extends Controller {
  static targets = ["field"];
  connect() {
    AdjustHeight(this);
  }

  copy(e) {
    e.preventDefault();
    e.target.classList.add("is-selected");

    // コピー
    this._copyText(e);
    // テキストエリアのサイズを調整
    this._adjustTextareaHeight();
    // テキストエリアにスクロール
    this._scrollToField();
    // フォーカス
    this._focus();

    // ボタンの選択状態を削除
    setTimeout(() => {
      e.target.classList.remove("is-selected");
    }, 2000);
  }

  _copyText(e) {
    const text =
      e.currentTarget.dataset["resumin-SelfPromotionExampleCopyTextValue"];
    const field = this.fieldTarget;
    field.value = [field.value, text].filter((v) => v !== "").join("\n");
    field.dispatchEvent(new Event("input", { bubbles: true }));
  }

  _adjustTextareaHeight() {
    const field = this.fieldTarget;
    this.adjustElementHeight(field);
  }

  _scrollToField() {
    const field = this.fieldTarget;
    field.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  }

  _focus() {
    const field = this.fieldTarget;
    field.focus();
  }
}
